import moment from 'moment'

function ShipmentDetail(args) {
    const showDate = (actual, estimate) => {
        // The moment function creates a local time object. Since the 
        // raw date strings are Zulu time at midnight (i.e. they are
        // date-only), this generally yields a local time from the
        // previous day. The object must be converted to UTC explicitly,
        // to obtain the correct date.
        if (actual) return `${moment(actual).utc().format("yyyy-MM-DD")}`
        if (estimate) return `${moment(estimate).utc().format("yyyy-MM-DD")} (est)`
        return '???'
    }

    let item = args.item

    return (<div className="shipment-details">
    <table className="detail">
        <tbody>
            <tr>
                <td>Your Control Number:</td>
                <td className="important"><strong>{item.usercontrol}</strong></td>
            </tr>
            <tr>
                <td>ShippersEdge TMS<sup>&trade;</sup> Number:</td>
                <td>{item.webquotecontrol}</td>
            </tr>
            <tr>
                <td>Shipment Created On:</td>
                <td className="important"><strong>
                    {moment(item.dtEntered)
                        .format("dddd, MMM D, yyyy [at] hh:mm a")}</strong></td>
            </tr>
            <tr>
                <td>Route:</td>
                <td>
                    <table className="route">
                        <tbody>
                            <tr>
                                <td>
                                    <div>{item.shipname}</div>
                                    <div className="important">
                                        <strong>{item.shipcity}, {item.shipstate}</strong>
                                    </div>
                                    <div>{item.shipzip}</div>
                                    <div>P/U {showDate(item.pudate, item.estpudate)}</div>
                                </td>
                                <td><strong>&rarr;</strong></td>
                                <td>
                                    <div>{item.consname}</div>
                                    <div className="important">
                                        <strong>{item.conscity}, {item.consstate}</strong>
                                    </div>
                                    <div>{item.conszip}</div>
                                    <div>DEL {showDate(item.deldate, item.estdeldate)}</div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </td>
            </tr>
            <tr>
                <td>Status:</td>
                <td className="important"><strong>{item.statusedi}</strong></td>
            </tr>
        </tbody>
    </table>
  </div>)

}

export default ShipmentDetail
